<template>
	<div class="select-matching-employee uk-margin-medium-top">

		<div class="uk-grid table-filter">
			<div class="uk-width-1-2@xl uk-margin-small-bottom">
				<div class="uk-grid">
					<div class="uk-width-1-2">
						<label for="pf-search" class="uk-form-label">Search</label>
						<div class="uk-form-controls">
							<input id="pf-search" type="text" name="pf-search" value="" class="uk-input" v-model="searchTerm" placeholder="Enter Search Terms" />
						</div>
					</div>
					<div class="uk-width-1-2">
						<div class="uk-form-label">Filter Date Range</div>
						<div class="uk-grid">
							<div class="uk-width-1-2">
								<datepicker ref="start_date" placeholder="Start Date" input-class="uk-input" @input="startUpdated" :use-utc=true :clear-button=true :typeable=true clear-button-icon="fa fa-times" format="MM/dd/yyyy"></datepicker>
							</div>
							<div class="uk-width-1-2">
								<datepicker ref="end_date" placeholder="End Date" @input="endUpdated" input-class="uk-input" :use-utc=true :clear-button=true :typeable=true clear-button-icon="fa fa-times" format="MM/dd/yyyy"></datepicker>
							</div>
						</div>
					</div>
				</div>

				<div class="uk-form-label uk-margin-top">Narrow Search By</div>
				<div class="uk-margin uk-grid-medium uk-child-width-auto uk-grid">
					<label>
						PO Number
						<input class="uk-checkbox" type="checkbox" value="po_number" v-model="checkedFilters" />
					</label>
					<label>
						Req. #
						<input class="uk-checkbox" type="checkbox" value="number" v-model="checkedFilters" />
					</label>
					<label>
						Manager
						<input class="uk-checkbox" type="checkbox" value="manager" v-model="checkedFilters" />
					</label>
					<label>
						Customer
						<input class="uk-checkbox" type="checkbox" value="customer" v-model="checkedFilters" />
					</label>
					<label>
						Craft
						<input class="uk-checkbox" type="checkbox" value="craft" v-model="checkedFilters" />
					</label>
					<label>
						Job Number
						<input class="uk-checkbox" type="checkbox" value="job_number" v-model="checkedFilters" />
					</label>
					<label>
						Include Archived
						<input class="uk-checkbox" type="checkbox" value="include_archived" v-model="checkedFilters" />
					</label>
				</div>
			</div>

			<div class="uk-width-1-4@xl uk-width-1-2@s uk-margin-small-bottom">
				<label class="uk-form-label">Business Unit:</label>
				<select class="uk-select" name="bu_id" v-model="businessUnitId">
					<option :value="-1">All</option>
					<option :value="0">Unassigned</option>
					<option v-for="bu in businessUnits" :value="bu.id">{{ bu.name }}</option>
				</select>
				<div class="uk-form-label uk-margin-small-top">Records Per Page</div>
				<select class="uk-select uk-width-1-4" v-model="pagination.limit">
					<option v-for="val in recordOptions" :value="val" >{{val}}</option>
				</select>
				<div class="uk-margin-top">
					<button class="uk-button uk-button-small uk-margin-small-bottom" @click="clearFilters()">Clear Search/Filters</button>
					<span v-if="searching" class="uk-align-right">
                            <img style="width: 18px;" src="/images/spinner2.gif" /> Loading...
					</span>
				</div>
			</div>
		</div>
		<button v-if="!searching" class="uk-button uk-button-primary" @click="startSearch">
			Search
		</button>
		<div class="uk-margin-medium-top">
			<pagination
				ref="pager"
				:count="pagination.count"
				:page="pagination.page"
				:per_page="pagination.limit"
				v-on:page="goToPage"
				:bottom="true"
			></pagination>
			<div class="uk-clearfix"></div>
			<div class="uk-flex uk-flex-start uk-flex-wrap uk-margin-medium-bottom">
				<div v-for="match in possibleMatches" class="uk-width-1-5@l uk-width-1-4@m uk-margin-small-right uk-margin-small-bottom match" :class="{'active':match.id == selectedMatch}" @click.prevent="selectMatch(match.id)">
					{{ match.name }} - {{ match.number }} <br />
					{{ match.customer }} <br />
					{{ match.job_number }}<br />
					{{ match.paylocity_number }}<br />
				</div>
			</div>
		</div>
		<a v-if="selectedMatch != null && timeId != null" class="uk-button uk-button-primary uk-align-right" :href="'/paylocity/merge/time/' + timeId + '/' + selectedMatch">Import Data</a>
		<button v-if="selectedMatch != null && timeId == null" class="uk-button uk-button-primary uk-align-right" @click="externalImport">Import Data</button>
	</div>
</template>

<script>
import Pagination from "./Table/Pagination";
import Datepicker from "vuejs-datepicker";
export default {
	name: "SelectMatchingRequisition",
	components:{
		Pagination,
		Datepicker
	},
	props:{
		timeId:{
			type: Number,
			default: null
		}
	},
	data() {
		return {
			startDate: null,
			endDate: null,
			recordOptions: [10,15,30,50],
			checkedFilters: [],
			typeCount: 0,
			req_ids: "",
			all_items: false,
			storageName:"requisition_match_settings",
			loadingStorage:false,
			businessUnits: [],
			businessUnitId: null,
			loading: false,
			possibleMatches:[],
			selectedFilter:"name",
			searchTerm: "",
			selectedMatch:null,
			searching: false,
			pagination:{
				page:1,
				limit:30,
				count: 0
			},
		}
	},
	mounted() {
		this.loadBusinessUnits();

	},
	methods: {
		startSearch(){
			let sd = null;
			let ed = null;
			if(this.startDate){
				sd = this.startDate.getUTCFullYear() + "-" + (this.startDate.getUTCMonth()+1) + "-" + this.startDate.getUTCDate();
			}
			if(this.endDate){
				ed = this.endDate.getUTCFullYear() + "-" + (this.endDate.getUTCMonth()+1) + "-" + this.endDate.getUTCDate();
			}
			this.pagination.page = 1;
			let qItems = {
				q: this.searchTerm,
				filters: this.checkedFilters,
				start: sd,
				end: ed,
				bu_id: this.businessUnitId == -1 ? null:this.businessUnitId,
				notPaylocity: true,
				limit: this.pagination.limit,
				page: this.pagination.page,
			};
			this.searching = true;
			axios.get("/api/requisition/list", {params: qItems}).then(
				(pack) => this.loadSearch(pack)
			).catch(
				() => this.failSearch()
			)
		},
		goToPage(i){
			this.searching = true;
			let sd = null;
			let ed = null;
			if(this.startDate){
				sd = this.startDate.getUTCFullYear() + "-" + (this.startDate.getUTCMonth()+1) + "-" + this.startDate.getUTCDate();
			}
			if(this.endDate){
				ed = this.endDate.getUTCFullYear() + "-" + (this.endDate.getUTCMonth()+1) + "-" + this.endDate.getUTCDate();
			}
			let qItems = {
				q: this.searchTerm,
				filters: this.checkedFilters,
				start: sd,
				end: ed,
				bu_id: this.businessUnitId == -1 ? null:this.businessUnitId,
				notPaylocity: true,
				limit: this.pagination.limit,
				page: i,
			};
			axios.get("/api/requisition/list", {params: qItems}).then(
				(pack) => this.loadSearch(pack)
			).catch(
				() => this.failSearch()
			)
		},
		loadSearch(pack){
			this.searching = false;
			if(pack.data.success){
				this.possibleMatches = pack.data.data;
				this.pagination.page = pack.data.pagination.page;
				this.pagination.limit = pack.data.pagination.limit;
				this.pagination.count = pack.data.pagination.total;
				//this.$refs.pager.$forceUpdate();
			}
		},
		failSearch(){
			this.searching = false;
			this.possibleMatches = [];
		},
		selectMatch(id){
			if(this.selectedMatch == id){
				this.selectedMatch = null;
			} else {
				this.selectedMatch = id;
			}
		},
		loadBusinessUnits(){
			axios.get("/api/bu/list").then(
				ax => this.updateBusinessUnits(ax),
				ax => this.updateBusinessUnits(ax))
		},
		updateBusinessUnits(pack) {
			if(pack.data.success){
				this.businessUnits = pack.data.data;
			}
			this.startSearch();
			/*if(GlobalStorage.has("req_business_unit_pay")){
				let buId = GlobalStorage.load("req_business_unit_pay");
				if(this.businessUnits.length > 0){
					for(let i = 0; i < this.businessUnits.length;++i){
						let bu = this.businessUnits[i];
						if(bu.id == buId){
							this.businessUnitId = buId;
							break;
						}
					}
				}
				if(buId === 0 || buId === -1){
					this.businessUnitId = buId;
				}
			}
			if(this.businessUnitId == null){
				this.businessUnitId = -1;
			}*/

		},
		clearFilters(){
			this.searchTerm = "";
			this.checkedFilters = [];
			this.startDate = null;
			this.endDate = null;
			this.businessUnitId = null;
			this.$refs.start_date.selectedDate = null;
			this.$refs.end_date.selectedDate = null;
			//GlobalStorage.save(this.storageName, null); //force clearing out in case it gets "stuck"
		},
		startUpdated(date){
			this.startDate = date;
		},
		endUpdated(date){
			this.endDate = date;
		},
		externalImport(){
			this.$emit("usereq", this.selectedMatch);
		}
	}
}
</script>
<style scoped></style>